import React, {Fragment, useState} from 'react'
import Row from '../../../../bootstrap/component/Row'
import Column from '../../../../bootstrap/component/Column'
import {
    LOWER_TEETH_FIRST_HALF,
    UPPER_TEETH_FIRST_HALF,
    LOWER_TEETH_SECOND_HALF,
    UPPER_TEETH_SECOND_HALF,
} from '../../../../treatment/state/plan/const'
import Select from '../../../../form/component/Select'
import SelectChip from '../../../../form/component/SelectChip'
import TextArea from '../../../../form/component/TextArea'
import LabelInput from '../../../../form/component/LabelInput'
import ContentBoxHeader from "../../../../layout/component/ContentBoxHeader";
import {formatDateTime} from "../../../../../util/datetime";

const TOOTH_INDICATION = ['C', 'I', 'V', 'M', 'B', 'x'].map(indication => ({
    id: indication,
    value: indication,
}))

const ADDITIONAL_INDICATION = [
    {
        value: 'clinic_opb',
        label: ' No Findings',
    },
    {
        value: 'CMD_Kurzbefund_lt2',
        label: ' CMD (Yes)',
    },
    {
        value: 'CMD_Kurzbefund_gt2',
        label: ' CMD (No)',
    },
    {
        value: 'parodontitis',
        label: 'PSI >3 (Periodontitis)',
    },
    {
        value: 'WKB_unabgeschlossen',
        label: 'Root canal treatment needed or not finished',
    },
    {
        value: 'other',
        label: 'Other (write in general comments)',
    },
]
const ToothCell = ({
    position,
    teethIndication = {},
    readOnly,
    changeToothIndication,
}) => {
    return (
        <td className={'teeth-cell-' + position}>
            <Select
                addEmpty={true}
                readOnly={readOnly}
                object={Object.assign({}, teethIndication)}
                onChange={changeToothIndication}
                valueList={TOOTH_INDICATION}
                name={position}
            />
        </td>
    )
}
const InfoLegend = ({ isInfoLegendShown, toggleInfoLegend }) => (
    <div className="tooltip">
        <button
            onClick={() => {
                toggleInfoLegend()
            }}
            className=" btn-primary btn-md info-button"
        >
            i
        </button>
        {isInfoLegendShown && (
            <span className="tooltiptext teethLegend">
                <p>i = Implant</p>
                <p>v = Veneer</p>
                <p>c = Caries</p>
                <p>b = Bridge or blocked crowns</p>
                <p>m = Milk tooth</p>
                <p> x = missing</p>
            </span>
        )}
    </div>
)

const AlignerTreatmentPhysicianAssessment = ({
    anamnesis,
    error,
    readOnly,
    udpateAnamnesis,
    saveAnamnesis,
    isInfoLegendShown,
    toggleInfoLegend,
}) => {

    const [form, setForm] = useState({...anamnesis.formData});
    const [editing, setEditing] = useState(false);
    const [loading, setLoading] = useState(false);

    const saveChanges = () => {
        setEditing(false);
        setLoading(true);
        udpateAnamnesis(form, anamnesis.templateKey)
        saveAnamnesis(anamnesis.templateKey)
        setLoading(false);
    }

    const cancelEditing = () => {
        setEditing(false);
        setForm({...anamnesis.formData})
    }

    const changeFormData = (name, value) => {
        setForm({
            ...form,
            [name]: value,
        })
    }

    if (!form) {
        return null
    }

    const changeToothIndication = (name, value) => {
        setForm({
            ...form,
            teethIndication: {
                ...form.teethIndication,
                [name]: value,
            },
        })
    }

    const TeethRow = ({ upperTeeth, lowerTeeth }) => (
        <React.Fragment>
            {upperTeeth && (
                <tr>
                    {upperTeeth.map(position => {
                        return <td key={position}>{position}</td>
                    })}
                </tr>
            )}
            <tr>
                {(upperTeeth || lowerTeeth).map(position => {
                    return (
                        <ToothCell
                            key={position}
                            changeToothIndication={changeToothIndication}
                            readOnly={!editing || readOnly}
                            teethIndication={form.teethIndication}
                            position={position}
                        />
                    )
                })}
            </tr>
            {lowerTeeth && (
                <tr>
                    {lowerTeeth.map(position => {
                        return <td key={position}>{position}</td>
                    })}
                </tr>
            )}
        </React.Fragment>
    )

    return (
        <div>

            {error && <div className="alert alert-danger" role="alert">
                {error.messgage}
            </div>}
            <ContentBoxHeader>
                <Row>
                    <Column layer={'md'} size={8}>
                        {anamnesis.createdByUser || ''}{' '}
                        {formatDateTime(anamnesis.created)}
                    </Column>
                    <Column layer={'md'} size={4}>
                        <div style={{textAlign: 'right'}}>
                            {(!editing && !readOnly) &&
                            <button onClick={() => setEditing(true)} className="btn btn-primary">
                                <i className="fa fa-edit"/>
                            </button>}
                            {editing && <Fragment>
                                <button onClick={cancelEditing}
                                        className="btn"
                                        disabled={loading}
                                        style={{marginLeft: '5px'}}
                                >Cancel</button>
                                <button onClick={saveChanges}
                                        className="btn btn-primary"
                                        disabled={loading}
                                        type="submit"
                                        style={{marginLeft: '5px'}}
                                >Save</button>
                            </Fragment>}
                        </div>
                    </Column>
                </Row>
                <Row top="M">
                    <Column layer={'md'} size={12}>
                        <div style={{textAlign: 'right'}}>
                            <InfoLegend
                                isInfoLegendShown={isInfoLegendShown}
                                toggleInfoLegend={toggleInfoLegend}
                            />
                        </div>
                    </Column>
                </Row>
            </ContentBoxHeader>
            <Row top="M" className="teeth-table-whole-div">
                <Column
                    size={6}
                    layer="lg"
                    className="no-padding teeth-table-right-border"
                >
                    <table className="teeth-table">
                        <tbody>
                            <TeethRow upperTeeth={UPPER_TEETH_FIRST_HALF} />
                            <TeethRow lowerTeeth={LOWER_TEETH_FIRST_HALF} />
                        </tbody>
                    </table>
                </Column>
                <hr className="teeth-table-divider" />
                <div className="teeth-table-divider-horizontal" />
                <Column size={6} layer="lg" className="no-padding">
                    <table className="teeth-table">
                        <tbody>
                            <TeethRow upperTeeth={UPPER_TEETH_SECOND_HALF} />
                            <TeethRow lowerTeeth={LOWER_TEETH_SECOND_HALF} />
                        </tbody>
                    </table>
                </Column>
            </Row>
            <Row top="M">
                <Column size={12}>
                    <LabelInput label="Findings">
                        <SelectChip
                            object={form}
                            name="additionalIndication"
                            readOnly={!editing || readOnly}
                            addEmpty={true}
                            valueList={ADDITIONAL_INDICATION}
                            onChange={changeFormData}
                        />
                    </LabelInput>
                </Column>
            </Row>
            <Row top="M">
                <Column size={12}>
                    <LabelInput label="Patients wishes">
                        <TextArea
                            name="treatmentExpectation"
                            object={form}
                            onChange={changeFormData}
                            className="textarea-treatment-expectation"
                            readOnly={!editing || readOnly}
                        />
                    </LabelInput>
                </Column>
            </Row>
        </div>
    )
}

export default AlignerTreatmentPhysicianAssessment



// WEBPACK FOOTER //
// ./src/modules/anamnesis/component/anamnesis/renderer/AlignerTreatmentPhysicianAssessment.js